import localeEn from '@angular/common/locales/en';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeBs from '@angular/common/locales/bs';
import localeDe from '@angular/common/locales/de';
import localeHr from '@angular/common/locales/hr';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeSl from '@angular/common/locales/sl';
import localeSr from '@angular/common/locales/sr-Latn';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { GlobalErrorHandler } from './interceptors/error.handler';
import { errorInterceptor } from './interceptors/error.interceptor';
import { jwtInterceptor } from './interceptors/jwt.interceptor';
import { ToastService } from './services/shared/toast.service';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeSl, 'sl');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeSr, 'sr-Latn');
registerLocaleData(localeBs, 'bs');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(TranslateModule.forRoot()),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
    ...provideTranslateHttpLoader({
      prefix: '/i18n/',
      suffix: '.json',
      enforceLoading: false,
      useHttpBackend: false,
    }),
    provideHttpClient(
      withInterceptors([
        jwtInterceptor,
        (req, next) => {
          const router = inject(Router);
          const toast = inject(ToastService);
          return errorInterceptor(req, next, router, toast);
        },
      ]),
    ),
    MessageService,
    ConfirmationService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler }, // TODO - check if this is valid
  ],
};
